import '@js/skin/layer.css'
import layer from '@js/layer'
var httpHeader = "";
var OSSConfig = {};

if((location.host.indexOf("localhost") > -1) || (location.host.indexOf("127.0.0.1") > -1) || (location.host.indexOf("192.168.50.101") > -1)) {
	httpHeader = "http://192.168.50.180:3998/api/";
	OSSConfig = {
		endpoint: 'oss-cn-shenzhen.aliyuncs.com',
		bucket: 'zykms',
		rootDir: 'kmstest'
	}
} else {
	httpHeader = "http://zhiyun-tech.com:4002/api/";
	OSSConfig = {
		endpoint: 'oss-cn-shenzhen.aliyuncs.com',
		bucket: 'zykms',
		rootDir: 'kms'
	}
}
function noCopy() {
	document.oncontextmenu = new Function("event.returnValue=false");
	document.onselectstart = new Function("event.returnValue=false");
}
function getLocalUserId() {
	var user = localStorage.getItem("user");
	if(user) {
		user = JSON.parse(user)
		return user.id;
	}
	else {
		return ;
	}
	
}
/*noCopy();*/
$.support.cors = true;
var common = {
	//ajax 封装
	OSSConfig:OSSConfig,
	httpHeader: httpHeader,
	get: function(url, backFunc,queryParam={},boolasync=true,beforeFun=()=>{}) {
//		console.log($.support.cors);
		queryParam.sid = getLocalUserId()
		$.ajax({
			type: "get",
			crossDomain: true,
			url: httpHeader + url, // 请求路径
			data:queryParam,
			dataType: "json",
			async: boolasync,
			beforeSend:function(){
				beforeFun()
			},
			success: function(data) {
				if(data.errcode == '10125') {
					localStorage.removeItem("user");
					location.href = "/login";
					return;
				}
				if(data.errcode == '10002') {
					history.go(-1)
					return;
				}
				backFunc(data);
			},
			error: function(XMLHttpRequest, textStatus, errorThrown) {
//				console.log(textStatus);
//				console.log("error");
			}
		});
	},
	//ajax post封装
	post: function(url, backFunc, queryParam={}, boolasync=true,beforeFun=()=>{}) {
		queryParam.sid = getLocalUserId()
		$.ajax({
			type: "post",
			url: httpHeader + url, // 请求路径
			dataType: "json",
			data: queryParam,
			async: boolasync,
			beforeSend:function(){
				beforeFun()
			},
			success: function(data) {
				if(data.errcode == '10125') {
					localStorage.removeItem("user");
					location.href = "/login";
					return;
				}
				if(data.errcode == '10002') {
					history.go(-1)
					return;
				}
				backFunc(data);
			},
		});
	},
	ajaxGet: function(url, backFunc) {
		$.ajax({
			type: "get",
			url: url, // 请求路径
			dataType: "json",
			success: backFunc
		});
	},
	toolTip: function(text) {
		var _html = $('<div class="tool-tip"><p>' + text + '</p></div>');
		if(!$('.tool-tip').length) {
			_html.appendTo(document.body);
			setTimeout(function() {
				_html.addClass('tip');
				setTimeout(function() {
					_html.removeClass('tip');
					setTimeout(function() {
						_html.remove();
					}, 300)
				}, 1000)
			}, 50)
		}
	},
	isPC: function() {
		var userAgentInfo = navigator.userAgent;
		var Agents = ["Android", "iPhone",
			"SymbianOS", "Windows Phone",
			"iPad", "iPod"
		];
		var flag = true;
		for(var v = 0; v < Agents.length; v++) {
			if(userAgentInfo.indexOf(Agents[v]) > 0) {
				flag = false;
				break;
			}
		}
		return flag;

	},
	getUrlParam: function(name) {
		var u = location.href;
		var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"),
			r = u.substr(u.indexOf("\?") + 1).match(reg);
		return r != null ? r[2] : "";
	},
	//活动倒计时方法
	/*
	 * [countDown description]
	 * @param  {[date]} endTime    [结束时间]
	 * @param  {[function]} update     [更新函数]
	 * @param  {[function]} handle     [结束函数]
	 * @param  {[string]} str        [格式化返回时间] //eg:   d:h  */
	countDown: function(endTime, update, handle, str, diffServer) {
		var serverTime = new Date().getTime() + (diffServer || 0);
		var endTime = new Date(endTime).getTime();
		var diffTime = (endTime - serverTime);
		var r = new Object();
		//r['a'] = checkTime(Math.floor(diffTime/(1000*60*60*24)));
		r['b'] = checkTime(Math.floor(diffTime / (1000 * 60 * 60) % 24));
		r['c'] = checkTime(Math.floor((diffTime / (1000 * 60) % 60)));
		r['g'] = checkTime(Math.floor((diffTime / (1000) % 60)));
		if(diffTime <= 0) {
			if(handle && typeof handle === 'function') {
				handle();
			}
		} else {
			if(typeof str !== 'string') {
				str = 'b:c:g';
			}
			str.split();
			var rs = '';
			for(var i = 0, l = str.length; i < l; i++) {
				if(r[str[i]] == undefined) {
					rs += str[i];
				} else {
					rs += r[str[i]];
				}
			}
			if(update && typeof update === 'function') {
				update(rs);
			}
			var that = this;
			setTimeout(function() {
				that.countDown(endTime, update, handle, str, diffServer);
			}, 1000);
		}

		function checkTime(i) {
			if(i < 10) {
				i = "0" + i;
			}
			return i;
		}
	},
	getToken: function() {
		var token = '';
		try {
			token = localStorage.getItem('token') || '';
		} catch(e) {
			token = '';
		}
		return token;
	},
	getSystemLanguage: function() {
		var language = navigator.browserLanguage ? navigator.browserLanguage : navigator.language,
			language = language.toLowerCase();
		var system = '';
		if(language.indexOf('zh-cn') > -1) {
			system = "ZH_CN";
		} else if(language.indexOf('en') > -1) {
			system = "en";
		} else if(language.indexOf('zh-tw') > -1) {
			system = "zh_tw";
		} else if(language.indexOf('ja') > -1) {
			system = "ja";
		} else {
			system = "";
		}
		return system;

	},
	getLanguage: function() {
		var language = '';
		try {
			language = common.getUrlParam("lang") || localStorage.getItem('SET_LANGUAGE') || common.getSystemLanguage();
		} catch(e) {
			language = '';
		}
		var arr = ["ZH_CN", "en", "zh_tw"];
		if(arr.indexOf(language) == -1) {
			language = common.getSystemLanguage() || localStorage.getItem('SET_LANGUAGE');
		}
		localStorage.setItem('SET_LANGUAGE', language);
		return language;
	},
	//获取文件扩展名
	getExtName: function(path) {
		// var filename = getFileName(path);
		var index = path.lastIndexOf('.');
		if(index == -1) {
			return '';
		}
		return path.substring(index);
	},
	//提示信息
	newTip: function(obj, text) {
		var _html = $('<div class="prompt" ><span class="cue">' + text + '</span></div>');
		if(!$('.prompt').length) {
//			console.log(obj.next())
			_html.appendTo(obj.next());
			setTimeout(function() {
				_html.addClass('tip');
				setTimeout(function() {
					_html.removeClass('tip');
					setTimeout(function() {
						_html.remove();
					}, 3000)
				}, 1000)
			}, 50)
		}
	},
	fillTip: function(text) {
		var _html = $('<div class="prompt"><span class="cueIcon"><img src="../../../static/images/sign_in_error.png"/></span><span class="cue">' + text + '</span></div>');
		if(!$('.prompt').length) {
			_html.appendTo($(".tipCommon"));
			setTimeout(function() {
				_html.addClass('tip');
				setTimeout(function() {
					_html.removeClass('tip');
					setTimeout(function() {
						_html.remove();
					}, 3000)
				}, 1000)
			}, 50)
		}
	},
	//获取json文件各语言名
	getKey: function() {
		var type = common.getLanguage();
//		console.log(type);
		//var key = 'chinese';
		var key = "";
		if(type === 'en') {
			key = 'English';
		} else if(type === 'ZH_CN') {
			key = 'chinese'
		} else if(type === 'zh_tw') {
			key = 'complex'
		}
		/*else{
		      key=''
		    }*/
		return key;
	},
	resize_img: function(pic, w, h) {
		var re_new_size = function(r) {
			//根据比率重新计算宽度
			return {
				w: pic.width / r,
				h: pic.height / r
			};
		};
		var re_offset = function(n) {
			//根据新的宽高度返回偏移量
			return {
				off_l: (n.w - w) * 0.5,
				off_t: (n.h - h) * 0.5
			};
		};
		var re_position = function(o, n) {
			//重新定位图片
			pic.style.cssText = "position:absolute;top:" + -o.off_t + "px;left:" + -o.off_l + "px;width:" + n.w + "px;height:" + n.h + "px;";
		};
		var execute = function(rate) { //总执行函数
			var new_size = re_new_size(rate),
				offset_new = re_offset(new_size);
			re_position(offset_new, new_size);
		};

		//判断变量
		var rate_of_w = pic.width / w,
			rate_of_h = pic.height / h,
			rate;
		if(rate_of_w >= 1) {
			//图片宽度大于显示区域宽度
			if(rate_of_h >= 1) {
				//且图片高度大于显示区域高度
				rate = Math.min(rate_of_w, rate_of_h);
			} else {
				//图片高度小于显示区域
				rate = pic.height / h;
			}
		} else {
			//图片宽度小于显示区域宽度
			if(rate_of_h >= 1) {
				//且图片高度大于显示区域高度
				rate = pic.width / w;
			} else {
				//图片高度小于显示区域高度
				rate = Math.min(rate_of_w, rate_of_h);
			}
		}
		execute(rate);
		//执行入口  
	},
	getTabIndex: function() {
		var tab = $('.tabChange > span');
		var activeTab = tab.filter('.act');
		var index = 0;
		if(activeTab.length == 1) {
			index = activeTab.index();
		} else {
			index = 0;
			tab.removeClass('act').eq(index).addClass('act');
		}
		return index;
	},
	goUrl: function(postUrl, data, redirectUrl) {
		$.post(postUrl, data, function(res) {
			if(res.code) {
				return layer.alert(res.msg);
			}
			location.href = redirectUrl;
		})
	},
	getFileName: function(path) {
		if(!path) {
			return '';
		}
		var pos = path.lastIndexOf('/');
		return path.substring(pos + 1);
	},

	getExtName: function(path) {
		var index = path.lastIndexOf('.');
		if(index == -1) {
			return '';
		}
		return path.substring(index);
	},

	html2text: function(html, maxlen) {
		var $div = $('<div>');
		$div.html(html);
		var text = $div.text();
		return text.slice(0, maxlen);
	},
	pathJoin: function(parts, sep) {
		var separator = sep || '/';
		var replace = new RegExp(separator + '{1,}', 'g');
		return parts.join(separator).replace(replace, separator);
	},

	ellipsis: function() {
		$('.ellipsis').each(function(i, item) {
			$(item).attr('title', $(item).text());
		})
	},

	getMediaHtml : function(mediaUrl, thumb) {
		var ext = getExtName(mediaUrl).toLowerCase();
		if(ext == '.mp4') {
			thumb = thumb || mediaUrl;
			return '<div class="zoom_video mp4" href="' + mediaUrl + '"><img src="' + thumb + '"><i class="fa fa-play-circle-o video"></i></div>'
		} else if(ext == '.swf') {
			thumb = thumb || mediaUrl;
			return '<div class="zoom_video swf" href="' + mediaUrl + '"><img src="' + thumb + '"><i class="fa fa-play-circle-o video"></i></div>'
		} else if(ext.match('jpg|jpeg|png|gif')) {
			thumb = thumb || mediaUrl;
			return '<img class="zoom_image" src="' + thumb + '" href="' + mediaUrl + '">';
		} else {
			thumb = thumb || mediaUrl;
			return '<a class="zoom_video" href="' + mediaUrl + '" target="_blank"><img src="' + thumb + '"><i class="fa fa-play-circle-o video"></i></a>'
		}
	},

	getFileHtml :function(url, opt) {
		if(!url) {
			return '';
		}
		opt = opt || {};
		var html = getMediaHtml(url);
		var str = '<tr class="fileitem"><td>' + html + '</td>';

		str += '<td style="word-break:break-all;width:70%;font-size:13px;color:#999;">';
		str += '<span class="fileurl">' + url + '</span>';
		str += '</td>';

		if(opt.sort) {
			str += '<td>';
			str += '<b class="sortup" style="cursor:pointer;"><span class="glyphicon glyphicon-arrow-up"></span></b>';
			str += '&ensp;';
			str += '<b class="sortdown" style="cursor:pointer;"><span class="glyphicon glyphicon-arrow-down"></span></b>';
			str += '</td>';
		}

		str += '<td><a class="delfile btn btn-danger btn-xs">删除<span class="delete glyphicon glyphicon-remove"></span></a></td>';
		str += '</div></tr>';

		return str;
	},

	exchangeFileItem :function($a, $b) {
		$a.detach().insertAfter($b);
	},

	 insertFileItem: function(selector, url) {
		$(selector).append(getFileHtml(url, {
			sort: true
		}));
		//update sort
		if($(selector).find('.fileitem').length <= 1) {
			return;
		}
		//$(selector).undelegate();
		$(selector).find('.sortup').unbind().bind('click', function(e) {
			var $b = $(this).closest('.fileitem');
			var $a = $b.prev();
			if($a.length) {
				exchangeFileItem($a, $b);
			}
		});
		$(selector).find('.sortdown').unbind().bind('click', function(e) {
			var $a = $(this).closest('.fileitem');
			var $b = $a.next();
			if($b.length) {
				exchangeFileItem($a, $b);
			}
		});
	},

	showUrlDialog : function(callback) {
		$(document).find('.modal_submit').off().on('click', function(e) {
			var url = $('.urlmodal_input').val();
			if(!url) {
				return layer.alert('请输入url地址');
			}
			callback(url);
			$('#urlModal').modal('hide');
		})
	},

	ossupload:function(file, storeAs, callback) {
		if(!file) {
			return layer.alert('请选择文件');
		}
		if((file.size).toFixed(2)>(1024*1024*1024)){
			return layer.alert('文件过大，请重新上传，不要超过1g');
		}
		$.get(httpHeader+"getAliyunOSSToken?access=rw&&id="+JSON.parse(localStorage.getItem("user")).id+"&&sid="+getLocalUserId(), function(ret) {
			if(ret.errcode) {
				return layer.alert(ret.errmsg);
			}
			var client = new OSS.Wrapper({
				accessKeyId: ret.AccessKeyId,
				accessKeySecret: ret.AccessKeySecret,
				stsToken: ret.SecurityToken,
				endpoint: 'https://' + OSSConfig.endpoint,
				bucket: OSSConfig.bucket
			});
			$('#progressDialog').modal({
				keyboard: false,
				backdrop: 'static'
			}).modal('show');
			client.multipartUpload(storeAs, file).then(function(result) {
				$('#progressDialog').modal('hide');
				callback(result)
			}).catch(function(err) {
				$('#progressDialog').modal('hide');
//				layer.alert(err);
			});
		})
	}

}
export default {
	common: common
}
//common end


//////////////////
// WEBPACK FOOTER
// ./static/js/common.js
// module id = /sA3
// module chunks = 0